(function () {
  if (window.__rumorTheme) return;
  window.__rumorTheme = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function markReady(el) {
    if (!el || el.dataset.rumorReady === 'true') return false;
    el.dataset.rumorReady = 'true';
    return true;
  }

  function initHeader(header) {
    if (!markReady(header)) return;

    var menuBtn = header.querySelector('[data-rumor-menu-toggle]');
    var mobile = header.querySelector('.rumor-mobile');
    var searchBtn = header.querySelector('[data-rumor-search-toggle]');
    var search = header.querySelector('.rumor-search');

    if (menuBtn && mobile) {
      menuBtn.addEventListener('click', function () {
        var open = menuBtn.getAttribute('aria-expanded') === 'true';
        menuBtn.setAttribute('aria-expanded', String(!open));
        mobile.hidden = open;
        header.classList.toggle('is-menu-open', !open);
        if (!open && searchBtn && search) {
          closeSearch();
        }
      });
    }

    function openSearch() {
      if (!searchBtn || !search) return;
      search.hidden = false;
      search.setAttribute('aria-hidden', 'false');
      searchBtn.setAttribute('aria-expanded', 'true');
      header.classList.add('is-search-open');
      window.requestAnimationFrame(function () {
        search.classList.add('is-open');
      });
      var input = search.querySelector('input[type="search"]');
      window.setTimeout(function () {
        if (input) input.focus();
      }, 280);
    }

    function closeSearch() {
      if (!searchBtn || !search) return;
      search.classList.remove('is-open');
      searchBtn.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-search-open');
      search.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (!header.classList.contains('is-search-open')) search.hidden = true;
      }, 420);
    }

    if (searchBtn && search) {
      search.setAttribute('aria-hidden', 'true');
      searchBtn.addEventListener('click', function () {
        if (searchBtn.getAttribute('aria-expanded') === 'true') {
          closeSearch();
        } else {
          openSearch();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
          closeSearch();
          searchBtn.focus();
        }
      });
    }
  }

  function initCountdown(timer) {
    if (!markReady(timer)) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      var end = new Date(String(timer.getAttribute('data-end') || '').replace(' ', 'T')).getTime();
      if (isNaN(end)) return;
      var diff = Math.max(0, end - Date.now());
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      var daysEl = timer.querySelector('[data-days]');
      var hoursEl = timer.querySelector('[data-hours]');
      var minsEl = timer.querySelector('[data-mins]');
      var secsEl = timer.querySelector('[data-secs]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initFilm(section) {
    if (!markReady(section)) return;

    var openBtn = section.querySelector('[data-rumor-film-open]');
    var modal = section.querySelector('[data-rumor-film-modal]');
    var player = section.querySelector('[data-rumor-film-player]');
    if (!openBtn || !modal || !player) return;

    var videoType = section.getAttribute('data-video-type') || '';
    var videoId = section.getAttribute('data-video-id') || '';
    var videoUrl = section.getAttribute('data-video-url') || '';
    var hasShopifyVideo = section.getAttribute('data-shopify-video') === 'true';

    function youtubeEmbed(id) {
      return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
    }

    function vimeoEmbed(id) {
      return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
    }

    function embedUrl() {
      if ((videoType === 'youtube' || videoType === 'YouTube') && videoId) return youtubeEmbed(videoId);
      if ((videoType === 'vimeo' || videoType === 'Vimeo') && videoId) return vimeoEmbed(videoId);

      var source = videoUrl || videoId || '';
      var yt = source.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/i);
      if (yt) return youtubeEmbed(yt[1]);
      var vm = source.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
      if (vm) return vimeoEmbed(vm[1]);
      return '';
    }

    function shopifyVideo() {
      return player.querySelector('video');
    }

    function openModal(event) {
      if (event) event.preventDefault();
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if (hasShopifyVideo) {
        var video = shopifyVideo();
        if (video) {
          video.controls = true;
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        }
        return;
      }

      var url = embedUrl();
      if (url) {
        player.innerHTML = '<iframe src="' + url + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Feature film"></iframe>';
      }
    }

    function closeModal() {
      modal.hidden = true;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (hasShopifyVideo) {
        var video = shopifyVideo();
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      } else {
        player.innerHTML = '';
      }
    }

    openBtn.addEventListener('click', openModal);
    section.querySelectorAll('[data-rumor-film-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initCarousel(carousel) {
    if (!markReady(carousel)) return;

    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    function amount() {
      var item = track.querySelector('[data-carousel-item], .rumor-carousel__item, .p2-lookbook__item');
      if (!item) return 300;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -amount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: amount(), behavior: 'smooth' });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.rumor-header').forEach(initHeader);
    root.querySelectorAll('[data-rumor-countdown]').forEach(initCountdown);
    root.querySelectorAll('.rumor-film').forEach(initFilm);
    root.querySelectorAll('.rumor-carousel, .p2-lookbook').forEach(initCarousel);
  }

  ready(function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
